(() => {
  if (window.__userInteractionGateInitialized) return;
  window.__userInteractionGateInitialized = true;

  const interactionEventName = "UserInteracted";
  const interactionEvents = ["pointerdown", "touchstart", "keydown", "scroll"];
  let hasInteracted = false;

  const listenerOptions = { passive: true };

  const cleanup = () => {
    interactionEvents.forEach((eventName) => {
      window.removeEventListener(
        eventName,
        onFirstInteraction,
        listenerOptions,
      );
    });
  };

  const dispatchInteraction = () => {
    if (hasInteracted) return;

    hasInteracted = true;
    window.__userInteracted = true;
    cleanup();

    document.dispatchEvent(new CustomEvent(interactionEventName));
  };

  const onFirstInteraction = () => {
    dispatchInteraction();
  };

  const init = () => {
    if (window.__userInteracted) return;

    interactionEvents.forEach((eventName) => {
      window.addEventListener(eventName, onFirstInteraction, listenerOptions);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
